import { Box } from "@mui/material";

import { Tag } from "../../tag/Tag";
import Text from "../../text/Text";
import Button from "../../button/Button";
import CustomDivider from "../../divider/Divider";
import { recommended } from "../../messages";

const AuthStatusCard = ({
  title,
  subtitle,
  description,
  icon,
  actions,
  isRecommended = false,
}) => {
  return (
    <Box className="activated-2fa">
      <Box display="flex" alignItems="center">
        <img alt="icon" src={icon} width={40} height={40} />
        <Box textAlign="left" margin="0px 10px">
          <Text size={16} font="bold">
            {title}
          </Text>
          {subtitle && (
            <Text size={16} font="light" className="grey-text">
              {subtitle}
            </Text>
          )}
        </Box>
        {isRecommended && <Tag text={recommended} variant="primary" />}{" "}
      </Box>
      <CustomDivider sx={{ margin: "18px 4px" }} />

      {description && (
        <Text size={16} font="regular" className="grey-text">
          {description}
        </Text>
      )}
      <Box display="flex" flexDirection="row" gap={2} marginTop="24px">
        {actions.map((button, index) => {
          return (
            <Button
              key={index}
              onClick={button.onClick}
              variant={button.variant}
              sx={{
                borderRadius: "4px !important",
                padding: "16px 24px !important",
                width: "100%",
              }}
              label={button.label}
              color={button.color}
              loading={button?.loading}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default AuthStatusCard;
